export default __webpack_public_path__ + "static/media/unlock-icon.d64aa966.svg";